<template>
<div>
	<modal-dialog
		:modal-visible="visible"
		title="Select Library File"
		:submit-visible="false"
		modal-size="modal-lg"
		v-on:closeModal="$emit('closeModal')">

		<field v-if="project || service" label="Source"
			col-class="col-md-4"
			:params="{type: 'select',options: ['Library','Files Tab']}"
			v-model="source"
			v-on:change="fetchFiles">
		</field>

		<field label="Tags"
			col-class="col-md-4"
			:params="{type:'select-multi',options: fileTagsOptions}"
			v-model="fileTagFilters"
			v-on:change="fetchFiles">		
		</field>

		<file-list-item
			v-for="file in mutatedFiles"
			:key="file.id"
			:id="file.file_id"
			:caption="file.caption"
			:date-uploaded="file.created_at"
			:filename="file.filename"
			:tags="file.tags"
			:uploaded-by="file.uploadedBy"
			:src="file.src"
			:non-editable="true"
			:other-buttons="[
				{
					icon:'fa-check-square',
					text:'Select',
					titleText:'Acknowledge reading/receiving this file',
					action:'select'
				}
			]"
			v-on:select="fileSelected(file)">
		</file-list-item>

		<!--
		<div>
			<search-bar
				style="min-width: 100%"
				class="mb-3"
				placeholder="Search files by name, caption, uploader, tag..."
				v-model="searchTerms"
				v-on:submit="fetchFiles">
			</search-bar>

			<file-list-item
				v-for="file in mutatedFiles"
				:key="file.id"
				:id="file.file_id"
				:caption="file.caption"
				:date-uploaded="file.created_at"
				:filename="file.filename"
				:tags="file.tags"
				:uploaded-by="file.uploadedBy"
				:src="file.src"
				:non-editable="true"
				:other-buttons="[
					{
						icon:'fa-check-square',
						text:'Select',
						titleText:'Acknowledge reading/receiving this file',
						action:'select'
					}
				]"
				v-on:select="fileSelected(file)">
			</file-list-item>
		</div>
		-->
	</modal-dialog>
</div>
</template>
<script type="text/javascript">

import ModalDialog from "@/components/ModalDialog"
import TableList from "@/components/TableList"
import SearchBar from "@/components/SearchBar"
import FileListItem from "@/components/FileListItem"
import Field from "@/components/Field"


export default {
	name: "LibraryFileSelectorModal",
	components: {
		ModalDialog,
		TableList,
		SearchBar,
		FileListItem,
		Field
	},
	props: [
		"visible",
		"project",
		"service"
	],
	data() {
		return {
			source: "Library",
			searchTerms: false,
			fileTagFilters: [],
			files: [],
			tags: []
		}
	},
	watch: {
		visible() {
			if (this.visible)
				this.fetchFiles()
		}
	},
	computed: {
		fileTagsOptions() {
			return this.optionify(this.tags,'name')
		},
		mutatedFiles() {
			return this.files.map(file => {

				file.uploadedBy = ""
				if ('CreatedBy' in file && file.CreatedBy) {
					let tokens = []

					if ('first_name' in file.CreatedBy && file.CreatedBy.first_name)
						tokens.push(file.CreatedBy.first_name)
					if ('last_name' in file.CreatedBy && file.CreatedBy.last_name)
						tokens.push(file.CreatedBy.last_name)

					file.uploadedBy = tokens.join(" ")
				}

				file.tags = []
				if ('FileTag' in file && file.FileTag)
					file.tags = file.FileTag.map(tag => tag.name)


				file.filename = ""
				file.src = ""
				file.thumbSrc = ""

				if ('LibraryUpload' in file && file.LibraryUpload) {

					if ('filename' in file.LibraryUpload && file.LibraryUpload.filename)
						file.filename = file.LibraryUpload.original_filename

					if (file.LibraryUpload.thumb_filename != "") {
						file.thumbSrc = this.apiRoot + 'resources/images/' + this.$store.sessionToken + '/' + file.LibraryUpload.thumb_filename
						file.src = this.apiRoot + 'resources/images/' + this.$store.sessionToken + '/' + file.LibraryUpload.thumb_filename
					}

					if (file.LibraryUpload.filename != "") {
						file.src = this.apiRoot + 'resources/images/' + this.$store.sessionToken + '/' + file.LibraryUpload.filename

						if (file.thumbSrc == "")
							file.thumbSrc = this.apiRoot + 'resources/files/' + this.$store.sessionToken + '/' + file.LibraryUpload.filename
					}
				}

				return file
			})
		}
	},
	methods: {
		fileSelected(file) {
			this.$emit('selected', this.cloneObj(file))
			this.$emit('closeModal')
		},
		/*
		fetchFiles() {
			const vm = this

			const terms = (this.searchTerms) ? this.searchTerms.trim() : ""   // no leading/trailing whitespaces

			if (terms == "") {
				this.files = []
				return
			}

			const include = [
				'UploadFile',
				{ model: 'FileTag', fields: ['name'] },
				{ model: 'User', fields: ['first_name', 'last_name'] }
			]

			// ugly, disgusting hack that we need to do because the "or" operator can't be used on sub-record filters
			const promises = [
				this.getJSON('LibraryFile/get', { include, filters: [['caption', terms, 'and', 'like']] }),
				this.getJSON('LibraryFile/get', { include, filters: [['UploadFile.original_filename', terms, 'and', 'like']] }),
				this.getJSON('LibraryFile/get', { include, filters: [['CreatedBy.first_name', terms, 'and', 'like']] }),
				this.getJSON('LibraryFile/get', { include, filters: [['CreatedBy.last_name', terms, 'and', 'like']] })
			]

			vm.spinner(true)

			Promise.all(promises).then(responses => {

				let seen = {}
				vm.files = []

				responses.forEach(response => {
					if (!response.success)
						return

					// Build out results, removing duplicates
					response.data.forEach(file => {
						if (!(file.id in seen)) {
							seen[file.id] = false      // hashmap for O(1) access
							vm.files.push(file)
						}
					})
				})

				vm.spinner(false)
			})
		},
		*/
		fetchFiles() {
			let vm = this

			this.$nextTick(() => {

				let resource = "LibraryFile"
				if (this.source == 'Files Tab') {
					if (this.project)
						resource = "JobFile"
					else if (this.service)
						resource = "ServiceFile"
				}	

				let params = {
					include: ["FileTag","LibraryUpload"],
				}

				let filters = []
				if (this.fileTagFilters.length > 0) {
					this.fileTagFilters.forEach(tagId => {
						filters.push(["FileTag.id",tagId])
					})
				}

				if (this.source == 'Files Tab') {
					if (this.project)
						filters.push(["job_id",this.project.id])
					else
						filters.push(["service_id",this.service.id])
				}

				if (filters.length > 0)
					params.filters = filters

				this.getJSON(resource + "/get",params).then(response => {
					if (response.success)
						vm.files = response.data
				})
			})
		},
		fetchTags() {
			let vm = this

			let tagParams = {
				filters: [
					["is_for_library",1]
				]
			}

			this.getJSON("FileTag/get",tagParams).then(response => {
				if (response.success)
					vm.tags = response.data
			})
		}
	},
	created() {
		if (this.tags.length == 0)
			this.fetchTags()
	}
}
</script>